import React from 'react';
import { Typography } from '@mui/material';
import { commSectionLabelSx } from './communicationsStyles';

interface Props {
  children: React.ReactNode;
  sx?: object;
}

const CommSectionLabel: React.FC<Props> = ({ children, sx }) => (
  <Typography variant="subtitle2" sx={{ ...commSectionLabelSx, ...sx }}>
    {children}
  </Typography>
);

export default CommSectionLabel;
